const url = {
  // 获取班级或小组列表
  listClassGroup: 'ebook/res/class/listClassGroup',
  // 首页 微课视频播放
  getSystemMicroVideoList: 'ebook/res/teacher/microLecture/getSystemMicroVideoList',
  // 上传
  uploadFile: 'ebook/res/teacher/teaResource/uploadFile',
  /**
     * 学习任务模块
    */

  // 获取指定学生的活动答案及批改信息
 // getAnswerWithReviseById: 'ebook/res/teacher/revise/getAnswerWithReviseById',
  // 保存活动批改
  saveActivityRevise: 'ebook/res/teacher/revise/saveActivityRevise',

  // 获取老师备课任务列表
  getTeacherTask: 'ebook/teacher/task/v3/getTeacherV3Task',
  // 编辑任务活动 获取活动形式列表
  getTaskActivityStyleList: 'ebook/teacher/task/v3/getTaskActivityStyleList',
  // 根据任务id获取任务下的活动，和任务发布到的班级列表
  getTaskActivityAndClassList: 'ebook/teacher/task/v3/getTaskActivityAndClassList',
  // 通过阅读类型获取相关阅读标题列表
  getRelatedReadTitleListByReadType: 'ebook/teacher/task/v3/getRelatedReadTitleListByReadType',
  // 获取指定班级下个人任务学生回答列表
  getPersonalAnswerPage: 'ebook/teacher/task/v3/getPersonalTaskAnswerPage',
  // 获取指定班级下群组任务学生回答列表
  getGroupAnswerPage: 'ebook/teacher/task/v3/getPersonalGroupTaskAnswerPage',
  // 保存或编辑学习任务和活动
  addOrModifyTask: 'ebook/teacher/task/v3/addOrModifyTask',
  // 获取学习任务（资源推荐)
  getRecommendTask: 'ebook/teacher/task/v3/getRecommendV3Task',
  // 使用学习任务资源
  useRecommendTask: 'ebook/teacher/task/v3/useRecommendV3Task',
  // 获取发布记录（使用记录）--新接口-记录和备课资源-点击使用调用相同的接口
  getTeacherTaskHistory: 'ebook/teacher/task/v3/getTeacherV3TaskPushHistory',
  // 使用历史发布中的学习任务资源--新接口-记录和备课资源-点击使用调用相同的接口
  useHistoryPublishTask: 'ebook/teacher/task/v3/useRecommendV3Task',
  // 删除学习任务
  deleteTaskByTaskId: 'ebook/teacher/task/v3/deleteTaskByTaskId',
  // 任务发布
  publishTask: 'ebook/teacher/task/v3/publishTask',
  // 任务反馈 查看详情
  getTaskActivityAnswerViewWithRecordById: 'ebook/teacher/task/v3/getTaskActivityAnswerViewWithRecordById',
  // 任务反馈 查看详情
  getAnswerWithReviseById: 'ebook/teacher/task/v3/getAnswerWithReviseById',
  // 获取用户提交记录
  getUserCommitHistoryList: 'ebook/teacher/task/v3/getUserCommitHistoryList',
  // 用户活动作品推荐
  setGood: 'ebook/teacher/task/v3/setGood',
  // 用户活动作品推荐
  cancelGood: 'ebook/teacher/task/v3/cancelGood',
  //  设置当前全局学生批改权限设置
  setClassStuReviseGlobalPermission: 'ebook/teacher/task/v3/setClassStuReviseGlobalPermission',
  // 设置单个答案批改权限
  setClassStuReviseSinglePermission: 'ebook/teacher/task/v3/setClassStuReviseSinglePermission',
  // 打回重做活动
  reformActivity: 'ebook/teacher/task/v3/reformActivity',
  // 提交教师活动批改
  commitActivityRevise: 'ebook/teacher/task/v3/commitActivityRevise',
  // 任务反馈 查看详情 评价列表点赞
  taskActivityRevisePraise: 'ebook/teacher/task/v3/taskActivityRevisePraise',
  // 任务反馈 查看详情 评价列表取消点赞
  taskActivityReviseCancelPraise: 'ebook/teacher/task/v3/taskActivityReviseCancelPraise',
  /**
     * 备课模块
    */
  // 获取学前准备资源推荐
  getPreStudyRecommendList: 'ebook/res/teacher/preStudy/getPreStudyRecommendList',
  // 教师保存更新单个学前准备
  savePreStudyPrepare: 'ebook/res/teacher/preStudy/savePreStudyPrepare',
  // 获取教师学前准备
  getTeacherPreStudy: 'ebook/res/teacher/preStudy/getTeacherPreStudy',
  // 删除学前准备
  deletePreStudy: 'ebook/res/teacher/preStudy/deletePreStudy',
  // 引用其他学前准备
  useOthersPreStudy: 'ebook/res/teacher/preStudy/useOthersPreStudy',
  // 获取学前准备备课发布历史（分页）
  getTeacherPreStudyHistory: 'ebook/res/teacher/preStudy/getTeacherPreStudyHistory',
  // 引用历史学前准备
  useHistoryPreStudy: 'ebook/res/teacher/preStudy/useHistoryPreStudy',
  /**
     * 练习模块 20220509
    */
  // 获取本课系统题库
  getSystemQuestionList: 'ebook/res/teacher/question/getSystemQuestionList',
  // 添加习题
  addTempQuestion: 'ebook/res/teacher/question/addTempQuestion',
  // 删除习题
  deleteTeacherTest: 'ebook/res/teacher/question/deleteTeacherTest',
  // 提交试卷
  commitTest: 'ebook/res/teacher/question/commitTest',
  // 获取教师试卷列表
  getTeacherTest: 'ebook/res/teacher/question/getTeacherTest',
  // 修改试卷标题
  modifyTitle: 'ebook/res/teacher/question/modifyTitle',
  // 获取试卷详情
  getTestInfoById: 'ebook/res/teacher/question/getTestInfoById',
  // 发布试卷到班级
  publish: 'ebook/res/teacher/class/publish',
  // 获取批改班级列表
  getReviseClassList: 'ebook/res/teacher/question/revise/getReviseClassList',
  // 通过班级获取学生列表（主观题）
  getReviseUserSubjectiveListByClassId: 'ebook/res/teacher/question/revise/getReviseUserSubjectiveListByClassId',
  // 通过班级获取学生列表（ke观题）
  getReviseUserObjectiveListByClassId: 'ebook/res/teacher/question/revise/getReviseUserObjectiveListByClassId',
  // 获取学生主观题列表
  getUserSubjectiveQuestionList: 'ebook/res/teacher/question/revise/getUserSubjectiveQuestionList',
  // 获取学生客观题列表
  getUserObjectiveQuestionList: 'ebook/res/teacher/question/revise/getUserObjectiveQuestionList',
  // 保存批改内容
  saveQuestionRevise: 'ebook/res/teacher/question/revise/saveQuestionRevise',
  // 提交批改内容
  commitQuestionRevise: 'ebook/res/teacher/question/revise/commitQuestionRevise',
  // 相关阅读
  getRelatedRead: 'ebook/res/teacher/relatedRead/getRelatedRead',
  // 根据相关阅读id 获取详细信息
  getRelatedReadInfo: 'ebook/res/teacher/relatedRead/getRelatedReadInfo',
  // 根据相关阅读id 获取详细信息
  getRelatedReadDetail: 'ebook/teacher/study/getRelatedReadInfo',
  // 获取本课系统题库（添加题库）
  getSystemQuestionList4Add: 'ebook/res/teacher/question/getSystemQuestionList4Add',
  mergeQuestionList: 'ebook/res/teacher/question/mergeQuestionList',
  // 回答与批改统计
  getAnswerStatistics: 'ebook/res/teacher/question/getAnswerStatistics',
  /** *
   * 写作指导模块 20220621
  */
  // 获取写作指导资源推荐
  getWritingGuideRecommendList: 'ebook/res/teacher/writingGuide/getWritingGuideRecommendList',
  // 教师保存单个写作指导
  saveWritingGuide: 'ebook/res/teacher/writingGuide/saveWritingGuide',
  // 获取教师写作指导
  getTeacherWritingGuide: 'ebook/res/teacher/writingGuide/getTeacherWritingGuide',
  // 获取教师写作指导备课历史（分页）
  getTeacherWritingGuideHistory: 'ebook/res/teacher/writingGuide/getTeacherWritingGuideHistory',
  // 删除写作指导
  deleteWritingGuide: 'ebook/res/teacher/writingGuide/deleteWritingGuide',
  // 使用其他写作指导
  useOthersWritingGuide: 'ebook/res/teacher/writingGuide/useOthersWritingGuide',
  // 使用历史备份中的写作指导（传参格式和返回格式同上
  useHistoryWritingGuide: 'ebook/res/teacher/writingGuide/useHistoryWritingGuide',
  // 获取写作范文
  getWritingGuideArticleList: 'ebook/res/teacher/writingGuide/getWritingGuideArticleList',
  // 保存或修改写作范文
  saveWritingGuideArticle: 'ebook/res/teacher/writingGuide/saveWritingGuideArticle',
  // 删除写作范文
  deleteWritingGuideArticle: 'ebook/res/teacher/writingGuide/deleteWritingGuideArticle',
  /** *
   * 学科素养模块 20220628
  */
  // 获取核心知识关键能力
  getTeacherKeyPoint: 'ebook/res/teacher/keyPoint/getTeacherKeyPoint',
  // 隐藏单条核心知识
  deleteTeacherKeyKnowledge: 'ebook/res/teacher/keyPoint/deleteTeacherKeyKnowledge',
  // 新增单条核心知识
  addTeacherKeyKnowledge: 'ebook/res/teacher/keyPoint/addTeacherKeyKnowledge',
  // 获取历史核心知识和能力
  getTeacherHistoryKeyPoint: 'ebook/res/teacher/keyPoint/getTeacherHistoryKeyPoint',
  // 使用历史核心知识和能力
  useHistoryKeyPoint: 'ebook/res/teacher/keyPoint/useHistoryKeyPoint',
  // 隐藏单条核心能力
  deleteTeacherKeyAbility: 'ebook/res/teacher/keyPoint/deleteTeacherKeyAbility',
  // 新增单条核心能力
  addTeacherKeyAbility: 'ebook/res/teacher/keyPoint/addTeacherKeyAbility',
  // 获取微课视频（分页）
  getTeacherMicroLecture: 'ebook/res/teacher/microLecture/getTeacherMicroLecture',
  // 新增微课视频
  add: 'ebook/res/teacher/microLecture/add',
  // 删除微课视频
  deleteById: 'ebook/res/teacher/microLecture/deleteById',
  // 获取教师微课备课历史（分页）
  getTeacherMicroLectureHistory: 'ebook/res/teacher/microLecture/getTeacherMicroLectureHistory',
  // 使用教师历史微课
  useHistoryMicroLecture: 'ebook/res/teacher/microLecture/useHistoryMicroLecture',
  // 获取教师微课资源推荐（分页）
  getMicroLectureRecommendList: 'ebook/res/teacher/microLecture/getMicroLectureRecommendList',
  // 使用其它教师微课
  useOthersMicroLecture: 'ebook/res/teacher/microLecture/useOthersMicroLecture',
  /**
   * 课文导读或标题解析 20220713
  */
  // 获取课文导读或标题解析资源推荐
  getTextGuidanceRecommendList: 'ebook/res/teacher/textGuidance/getTextGuidanceRecommendList',
  // 教师保存课文导读或标题解析
  saveTextGuidance: 'ebook/res/teacher/textGuidance/saveTextGuidance',
  // 获取教师课文导读或标题解析（分页）
  getTeacherTextGuidance: 'ebook/res/teacher/textGuidance/getTeacherTextGuidance',
  // 获取教师课文导读或标题解析备课发布历史（分页
  getTeacherTextGuidanceHistory: 'ebook/res/teacher/textGuidance/getTeacherTextGuidanceHistory',
  // 删除其它教师课文导读或标题解析
  deleteTextGuidance: 'ebook/res/teacher/textGuidance/deleteTextGuidance',
  // 使用其他教师课文导读或标题解析
  useOthersTextGuidance: 'ebook/res/teacher/textGuidance/useOthersTextGuidance',
  // // 获取课文导读或标题解析资源推荐
  // getTextGuidanceRecommendList: 'ebook/res/teacher/textGuidance/getTextGuidanceRecommendList',
  // 使用历史备份中的文章赏析（传参格式及返回值格式同上)
  useHistoryTextGuidance: 'ebook/res/teacher/textGuidance/useHistoryTextGuidance',
  /**
   * 学生端预览模块
  */

  /**
   * 购买 书籍 相关模块 20220713
  */
  listPageBuyBook: 'ebook/res/listPageBuyBook',
  // 根据教材ID获取体例列表
  styleList: 'ebook/res/styleList',
  // 保存课程记录
  saveLessonRecords: 'ebook/res/lessonRecord/saveLessonRecords',
  // 获取课程记录
  getLessonRecords: 'ebook/res/lessonRecord/getLessonRecords',
  /**
   * 学前准备 预览模块专用 20220715
  */
  // 学前准备备课预览
  getTeacherPreStudyPreview: 'ebook/res/teacher/preStudy/getTeacherPreStudyPreview',
  // 学习任务备课预览
  getTeacherTaskPreview: 'ebook/res/teacher/task/getTeacherTaskPreview',
  // 标题解析备课预览
  getTeacherTextGuidancePreview: 'ebook/res/teacher/textGuidance/getTeacherTextGuidancePreview',
  // 写作指导备课预览
  getTeacherWritingGuidePreview: 'ebook/res/teacher/writingGuide/getTeacherWritingGuidePreview',
  // 学科素养备课预览
  getTeacherKeyPointPreview: 'ebook/res/teacher/keyPoint/getTeacherKeyPointPreview',
  // 微课备课预览
  getTeacherMicroLecturePreview: 'ebook/res/teacher/microLecture/getTeacherMicroLecturePreview',
  // 练习备课预览
  getTeacherTestPreview: 'ebook/res/teacher/question/getTeacherTestPreview',
  // 参考教案
  getResources: 'ebook/res/teacher/systemResourceBase/getResourcesByStyleId',
  // 根据体例ID获取课文内容
  paragraphList: 'ebook/res/paragraphList',
  // 相关阅读下一篇
  getNextRelatedReadInfo: 'ebook/res/teacher/relatedRead/getNextRelatedReadInfo',

  // 获取当前教师所在班级列表
  getSimpleClaList: 'ebook/class/v3/common/getSimpleClaList',
  // 获取当前教师所在班级列表
  getClaList: 'ebook/class/v3/common/getClaList',
  // 请求班级公告
  getClassAnnouncement: 'ebook/class/v3/common/getClassAnnouncement',
  // 创建班级公告
  pushClassAnnouncement: 'ebook/class/v3/common/pushClassAnnouncement',
  // 根据班级 id 解散班级
  dissolveClass: 'ebook/class/v3/tea/dissolveClass',
  // 教师创建班级
  createClass: 'ebook/class/v3/tea/createClass',
  // 教师创建班级
  getClaMembersByClassId: 'ebook/class/v3/common/getClaMembersByClassId',
  // 根据班级修改班级名称
  updateClassName: 'ebook/class/v3/tea/updateClassName',
  // 是否有学生成员申请加入班级
  getClassIsStuJoin: 'ebook/class/v3/tea/getClassIsStuJoin',
  // 对群组或班级成员取消禁言
  cancelForbiddenWords: 'ebook/class/v3/tea/cancelForbiddenWords',
  // 对群组或班级成员禁言
  setForbiddenWords: 'ebook/class/v3/tea/setForbiddenWords',
  // 获取本班级学生申请加入列表
  getClassJoinApplyList: 'ebook/class/v3/tea/getClassJoinApplyList',
  // 同意或拒绝某个同学加入班级
  setStudentsApplyClass: 'ebook/class/v3/tea/setStudentsApplyClass',
  // 班级成员转班
  classStuOfChange: 'ebook/class/v3/tea/classStuOfChange',
  // 班级成员退出或移除
  delClassStu: 'ebook/class/v3/common/delClassStu',
  // 根据用户id 获取用户班级班级及班级小组（不包括成员信息）
  getV3MyClassAndClassGroup: 'ebook/class/v3/common/getV3MyClassAndClassGroup',

  // 根据班级小组id 获取班级小组成员
  getClassGroupMembers: 'ebook/class/v3/common/getClassGroupMembers',
  // 创建小组
  createClassGroup: 'ebook/class/v3/tea/createClassGroup',
  // 班级随机创建分组
  createRandomClassGroup: 'ebook/class/v3/tea/createRandomClassGroup',
  // 根据班级id 获取班级小组总人数
  listGroupByClassId: 'ebook/class/v3/tea/listGroupByClassId',
  // 根据班级id 获取班级小组总人数
  listClassGroupV3: 'ebook/class/v3/tea/listClassGroup',
  // 班级小组成员设置为组长
  saveClassGroupLeader: 'ebook/class/v3/tea/saveClassGroupLeader',
  // 班级小组成员转组
  classGroupStuOfChange: 'ebook/class/v3/tea/classGroupStuOfChange',
  // 班级小组成员退出或移除
  delClassGroupStu: 'ebook/class/v3/common/delClassGroupStu',
  // 修改班级小组名称
  updateClassGroupName: 'ebook/class/v3/tea/updateClassGroupName',
  // 解散小组
  dissolveClassGroup: 'ebook/class/v3/tea/dissolveClassGroup',

  // 根据用户id获取环信登陆token
  getUserLoginToken: 'ebook/class/v3/common/getUserLoginToken',
  // 注册环信用户
  registerInstantMessage: 'ebook/class/v3/common/registerInstantMessage',

  // 教师端首页获取统计数据（柱状图 和雷达图）
  getHomePageStatistics: 'ebook/teacher/statistics/getHomePageStatistics',
  // 分页获取视频列表（首页 查看更多）
  getMediaPage: 'ebook/teacher/live/getMediaPage',
  // 统计获取教师当前课程任务下活动的学生回答数量
  getHomepageTaskStatistics: 'ebook/teacher/homePage/getHomepageTaskStatistics',
  // 统计获取课程习题的学生回答数量
  getHomepageExerciseStatistics: 'ebook/teacher/homePage/getHomepageExerciseStatistics',
  // 获取蜗牛视频分类列表（仅包含分类id和分类标题）
  getSimpleMediaCategoryList: 'ebook/teacher/live/getSimpleMediaCategoryList',

  // 根据用户id 获取用户信息
  getUserInfoByUserId: 'auth/res/encrypt/getUserInfoByUserId',
  // 更新用户基本信息
  updateUserInfo: 'auth/res/encrypt/updateUserInfo',
  // 根据用户id码修改密码
  updatePasswordByUserId: 'auth/res/encrypt/updatePasswordByUserId',
  // 统计增加蜗牛视频播放次数
  saveMediaPlayCount: 'ebook/teacher/live/saveMediaPlayCount' ,

  // 根据据环信消息id 撤回消息清除本地记录
  messageRetraction: 'ebook/class/common/chat/messageRetraction'
}
export default url
